import React from 'react';

function ReproduccionVideoIni() {
  return (
    <div className="container d-flex align-items-center justify-content-between my-5">
      <div className="col-md-6">
        {/* Video local */}
        <video className="w-100" controls>
          <source src="/videos/viajeprimaria.mp4" type="video/mp4" />
          Tu navegador no soporta la reproducción de videos.
        </video>
      </div>
      <div className="col-md-6">
        {/* Texto */}
        <h2 className="text-center">Visita a la Estación de Trenes</h2>
        <p className="mt-3">
          En el marco del cierre del trabajo de ciencias sociales en relación
          con los medios de transporte, 2do grado realizó una visita a la estación de trenes,
          aeropuerto y terminal de ómnibus. En esta última compartieron una muy rica merienda. 
          Terminaron el recorrido en el centro de trasbordo del Parque Oliver donde también disfrutaron de los
        </p>
      </div>
    </div>
  );
}

export default ReproduccionVideoIni;
